import { ModuleWithProviders, NgModule } from "@angular/core";
import { BiosealGenerationComponent } from "./bioseal-generation.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { FacePadModule } from "@id3/face-pad";
import { NgxsModule } from "@ngxs/store";
import { ConfigurationMenuComponent } from "./components/configuration-menu/configuration-menu.component";
import { BiosealUserFormComponent } from "./components/forms/bioseal-user-form/bioseal-user-form.component";
import { GlobalState } from "./shared/store/state/global.state";
import { BioSealState } from "./shared/store/state/bioseal.state";
import { FaceState } from "./shared/store/state/face.state";
import { Id3StepperModule } from "@id3/tools";
import { BiometricsComponent } from "./components/biometrics/biometrics.component";
import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { DisplayComponent } from "./components/display/display.component";
import { ToastModule } from "primeng/toast";
import { BarcodeTypeSelectionComponent } from "./components/barcode-type-selection/barcode-type-selection.component";
import { UseCaseMenuComponent } from "./components/use-case-menu/use-case-menu.component";
import { VaccinationUserFormComponent } from "./components/forms/vaccination-user-form/vaccination-user-form.component";
import { NgxsLoggerPluginModule } from "@ngxs/logger-plugin";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import { BioSealGenerationConfigOptions } from "./shared/model/options.model";
import { CovidTestUserFormComponent } from './components/forms/covid-test-user-form/covid-test-user-form.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { IdUploadComponent } from './components/id-upload/id-upload.component';
import { IdState } from "./shared/store/state/id.state";
import { EventUserFormComponent } from './components/forms/event-user-form/event-user-form.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    BiosealGenerationComponent,
    ConfigurationMenuComponent,
    BiosealUserFormComponent,
    BiometricsComponent,
    DisplayComponent,
    BarcodeTypeSelectionComponent,
    UseCaseMenuComponent,
    VaccinationUserFormComponent,
    CovidTestUserFormComponent,
    IdUploadComponent,
    EventUserFormComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    NgxsModule.forRoot([GlobalState, BioSealState, FaceState, IdState]),
    RouterModule,
    CommonModule,
    Id3StepperModule,
    ToastModule,
    FacePadModule,
    NgxIntlTelInputModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [BiosealGenerationComponent],
  bootstrap: [BiosealGenerationComponent],
})
export class BiosealGenerationModule {
  static forRoot(
    options?: BioSealGenerationConfigOptions
  ): ModuleWithProviders<any>[] {
    return [
      NgxsLoggerPluginModule.forRoot({ disabled: options.logsDisabled }),
      { ngModule: BiosealGenerationModule, providers: [] },
    ];
  }
}
